import {Routes} from "@angular/router";

export const routes: Routes = [
    {
        path: 'news',
        loadChildren: () => import('@_basic/news/page-news.module').then(m => m.PageNewsModule)
    },
    {
        path: 'shop',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/article/sub-page-article.module').then(m => m.SubPageArticleModule)
    },
    {
        path: 'sortiment',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/article/sub-page-article.module').then(m => m.SubPageArticleModule)
    },
    {
        path: 'customer',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/customer/sub-page-customer.module').then(m => m.SubPageCustomerModule)
    },
    {
        path: 'user',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/user/sub-page-user.module').then(m => m.SubPageUserModule)
    },
    {
        path: 'cart',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/cart/sub-cart.module').then(m => m.SubCartModule)
    },
    {
        path: 'checkout',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/checkout/sub-checkout.module').then(m => m.SubCheckoutModule)
    },
    {
        path: ':path',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/dynamic-page/sub-dynamic-page.module').then(m => m.SubDynamicPageModule)
    },

    {
        path: '',
        loadChildren: () => import('@shop_allgaeu-brennerei_de/dynamic-page/sub-dynamic-page.module').then(m => m.SubDynamicPageModule)
    }
];
